import { IMediaModel, TimeHelper } from "@nf/common";
import type { Movie, WithContext } from "schema-dts";

interface MediaSchemaData {
  media: IMediaModel;
  actors?: string[];
  directors?: string[];
  image?: string;
  trialUrl?: string;
}

const getMediaSchema = ({
  media,
  actors,
  directors,
  image,
  trialUrl,
}: MediaSchemaData): WithContext<Movie> => {
  const title = media?.Title;
  const description =
    media?.Description ||
    media?.ShortDescription ||
    media?.LongDescription ||
    media?.Title;

  return {
    "@context": "https://schema.org",
    "@type": "Movie",
    name: title,
    description: description,
    image,
    dateCreated: media?.Year ? `${media?.Year}` : "",
    director: directors?.map((director) => ({
      "@type": "Person",
      name: director ?? "",
    })),
    actor: actors?.map((actor) => ({
      "@type": "Person",
      name: actor ?? "",
    })),
    trailer: media.TrailerMediaId
      ? {
          "@type": "VideoObject",
          name: `Official Trailer ${title}`,
          description: description,
          dateCreated: media?.Year ? `${media?.Year}` : "",
          uploadDate: media?.AvailableFrom
            ? TimeHelper.toISOString(media.AvailableFrom)
            : undefined,
          thumbnailUrl: image ?? "",
          embedUrl: trialUrl,
        }
      : undefined,
  };
};

export default getMediaSchema;
